/**
 * Generated by orval v8.5.3 🍺
 * Do not edit manually.
 * Space Invoices API
 * REST API for invoice management, customer management, and accounting operations. Features include cursor-based pagination for efficient data navigation, flexible JSON querying with MongoDB-style operators, full-text search across multiple fields, and comprehensive metadata support for custom tracking.
 * OpenAPI spec version: 1.0.0
 */

/**
 * Determined transaction type based on geography and tax status. 3w_b2b/3w_b2c = third-world (non-EU) B2B/B2C.
 * @nullable
 */
export type TransactionTypeCheckResponseTransactionType = typeof TransactionTypeCheckResponseTransactionType[keyof typeof TransactionTypeCheckResponseTransactionType] | null;


export const TransactionTypeCheckResponseTransactionType = {
  domestic: 'domestic',
  intra_eu_b2b: 'intra_eu_b2b',
  intra_eu_b2c: 'intra_eu_b2c',
  '3w_b2b': '3w_b2b',
  '3w_b2c': '3w_b2c',
} as const;
